import React, { useState, useCallback } from 'react';
import './SignIn.css';
import houseImage from './house.jpg';
import logoImage from './apnaghar.png';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { auth, db } from './firebase';
import { doc, getDoc } from 'firebase/firestore';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ClipLoader } from 'react-spinners';

const SignIn = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ email: '', password: '', termsAccepted: false });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleUserLogin = useCallback(async (user) => {
    try {
      const userRef = doc(db, 'user-data', user.uid);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        toast.error('❌ User not found. Please register first.');
        await auth.signOut();
        return;
      }

      const userData = userSnap.data();

      // Save user info locally
      localStorage.setItem('apnaghar_uid', userData.customId || user.uid);
      localStorage.setItem('role', userData.role || 'user');
      localStorage.setItem('username', userData.username || 'User');
      localStorage.setItem('email', userData.email || user.email);

      // Redirect based on role
      if ((userData.role || 'user') === 'admin') navigate('/master-control');
      else navigate('/homepage');

    } catch (err) {
      console.error(err);
      toast.error('❌ Sign-in failed.');
    }
  }, [navigate]);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    if (!formData.termsAccepted) return toast.error('❌ Accept Terms & Conditions.');

    setLoading(true);
    try {
      // Persist login
      await setPersistence(auth, browserLocalPersistence);

      // Sign in with email/password
      const userCredential = await signInWithEmailAndPassword(auth, formData.email.trim(), formData.password);
      const user = userCredential.user;

      // Check user-data and login
      await handleUserLogin(user);

    } catch (err) {
      console.error(err);
      if (err.code === 'auth/user-not-found') toast.error('❌ No user found.');
      else if (err.code === 'auth/wrong-password') toast.error('❌ Wrong password.');
      else if (err.code === 'auth/invalid-email') toast.error('❌ Invalid email.');
      else toast.error('❌ Sign-in failed.');
    } finally {
      setLoading(false);
    }
  }, [formData, handleUserLogin]);

  return (
    <div className="signin-container">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      <div className="signin-card">
        <img src={logoImage} alt="Logo" className="card-logo" />
        <div className="signin-left">
          <h1 className="signin-heading">Sign In</h1>
          <form onSubmit={handleSubmit}>
            <label>Email Address</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter email"
              required
            />

            <label>
              Password
              <span className="forgot-link" onClick={() => navigate('/forgot-password')}>Forgot password?</span>
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter password"
              required
            />

            <label>
              <input
                type="checkbox"
                name="termsAccepted"
                checked={formData.termsAccepted}
                onChange={handleChange}
              />
              I accept <span className="terms-link" onClick={() => navigate('/terms')}>Terms & Conditions</span>
            </label>

            <button type="submit" className="signin-btn" disabled={loading}>
              {loading ? <ClipLoader size={20} color="#fff" /> : 'Sign In'}
            </button>

            <p className="register-link">
              Don't have an account? <span onClick={() => navigate('/register')}>Register here</span>
            </p>
          </form>
        </div>
        <div className="signin-right">
          <img src={houseImage} alt="House" />
        </div>
      </div>
    </div>
  );
};

export default SignIn;
